import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { financeHomeRoute, HttpStatus } from 'config/Api.Config';
import useContractRefundPayment from './Finance.ContractRefundPayment.Hooks';
import FinanceContractRefundPaymentCancel from './components/Finance.ContractRefundPayment.Cancel';
import ContractRefundPaymentSendEmail from './components/Finance.ContractRefundPayment.SendEmail';
import ContractRefundPaymentList from './sections/Finance.ContractRefundPayment.List';

export const financeContractRefundPaymentIndexRoute = financeHomeRoute + '/contractRefundPayment/:action?/:id?';
export default function FinanceContractRefundPaymentIndex() {
  const contractRefundPaymentHook = useContractRefundPayment();

  if (!contractRefundPaymentHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={contractRefundPaymentHook}
        render={({ pageRouter }) => {
          return (
            <>
              <ContractRefundPaymentList />
              {pageRouter.params?.id && pageRouter?.params?.action === 'sendEmail' && (
                <ContractRefundPaymentSendEmail />
              )}
              {pageRouter.params?.id && pageRouter?.params?.action === 'cancel' && (
                <FinanceContractRefundPaymentCancel />
              )}
            </>
          );
        }}
      />
    </>
  );
}
